import { render } from "./ListPointagePage.vue?vue&type=template&id=74ce88aa&ts=true"
import script from "./ListPointagePage.vue?vue&type=script&lang=ts"
export * from "./ListPointagePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__